import React from "react";
import { BrowserRouter } from "react-router-dom";
import theme from "theme";
import { ChakraProvider } from "@chakra-ui/react";
import Routes from "routes/Routes";
import UserProvider from "context/user";
import { ApolloProvider } from "@apollo/client";
//import { contentful } from "api/contentful/client";
import { VideoProvider } from "context/session/VideoProvider";
import { AliveScope } from "context/AliveScope";
import { ChatProvider } from "context/session/ChatProvider";
import ModalProvider from "context/modal";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const App: React.FC = () => {
  //console.log(theme);
  return (
    //<ApolloProvider client={contentful}>
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <ModalProvider>
            <VideoProvider
              onError={(error: Error) => console.log(error.message)}
            >
              <AliveScope>
                <ChatProvider>
                  <BrowserRouter>
                    <Routes />
                  </BrowserRouter>
                </ChatProvider>
              </AliveScope>
            </VideoProvider>
          </ModalProvider>
        </UserProvider>
      </QueryClientProvider>
    </ChakraProvider>
    //</ApolloProvider>
  );
};

export default App;
